(function() {
	angular.module('meanApp').controller('navigationCtrl', navigationCtrl);

	navigationCtrl.$inject = [
		'$location',
		'titleFactory',
		'authentication',
		'loginModal',
		'alert',
		'searchData',
		'User',
		'$rootScope',
		'usersManager',
		'$state',
		'$scope',
		'$q',
		'currentUser',
		'searchModal'
	];
	function navigationCtrl(
		$location,
		titleFactory,
		authentication,
		loginModal,
		alert,
		searchData,
		User,
		$rootScope,
		usersManager,
		$state,
		$scope,
		$q,
		currentUser,
		searchModal
	) {
		var vm = this;

        $rootScope.currentYear = new Date().getFullYear();
		$rootScope.hasScrolled = false;
		$rootScope.isMobile = window.innerWidth < 465;
		//always keep the variable for window width up to date
		// Returns a function, that, as long as it continues to be invoked, will not
		// be triggered. The function will be called after it stops being called for
		// N milliseconds. If `immediate` is passed, trigger the function on the
		// leading edge, instead of the trailing.
		var debounce = function(func, wait, immediate) {
			var timeout;
			return function() {
				var context = this,
					args = arguments;
				var later = function() {
					timeout = null;
					if (!immediate) func.apply(context, args);
				};
				var callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (callNow) func.apply(context, args);
			};
		};

		$scope.$state = $state; //This is used in the mobile toolbar

		//For Google indexation strategy and have nice cards to be checked on production
		$scope.$root.ld = {
			'@context': 'http://schema.org/',
			'@type': 'WebSite',
			name: 'Fraise ou Bacon',
			image: 'https://fraiseoubacon.com/images/coloredlogo.svg',
			description: 'Moteur de recherche de recettes. Votre prochain repas se trouve ici',
			url: 'https://fraiseoubacon.com/'
		};

		/*window.onResize = debounce(function() {
            $rootScope.isMobile = window.innerWidth < 400;
        }, 250);*/
		window.addEventListener(
			'resize',
			debounce(function() {
				$rootScope.isMobile = window.innerWidth < 465;
				$rootScope.$apply(); //force the refresh
			}, 250)
		);
		/*window.onResize = function() {
            console.log('resized');
        };*/
		/*$rootScope.loadMoreRecipes = function() {
            console.log('in the nav end scroll detected');
        };*/

		//TODO maybe not useful anymore in that way when everything has been migrated
		currentUser.get().then(function(userModel) {
			$rootScope.currentUser = userModel;
		});

		console.log('current user is in controller navigation test');
		console.log($rootScope.currentUser);
		$rootScope.isLoggedIn = authentication.isLoggedIn();


		vm.getCentralButtonHref = function() {
			var href='/',
			step = $state.params && $state.params.step && parseInt($state.params.step);

			if(!step) {
				href = '/recherche/etape/1';
			}
			else if (step < 4) {
				href = '/recherche/etape/' + (step+1);
			}

			return href;
		};

		vm.canGoToNextSearchPageWithNoCheck

		vm.isAtLeastOneTagSelected = function() {
			return searchData.getTagsSelected().length > 0;
		};

		vm.selectTab = function(tabNumber) {
			console.log('select tab in navigation controller');
			//alert.push('success', 'tab number is' +tabNumber);
			vm.tabSelected = tabNumber;
			window.scrollTo(0, 0);
			//alert.push('success', 'after windo scroll');
			switch (tabNumber) {
				case 0:
					$state.go('home');
					break;
				case 1:
					console.log('state is', $state, $state.current, $state.params);
					//if we are in search mode go to next, otherwise access the search mode
					if ($state.current.name === 'recipeSearchStep') {
						//go to next
						var step = parseInt($state.params.step);
						if (step < 4) {
							$state.go('recipeSearchStep', {
								step: step + 1 + ''
							});
						} else {
							var tagsSelected = searchData.getTagsSelected();
							if (tagsSelected.length > 0) {
								$state.go('recipeSearchResult');
							} else {
								alert.push('info', 'Veuillez sélectionner au moins 1 tag');
								if (!($rootScope.currentUser && $rootScope.currentUser._id)) {
									//means no user is logged in
									$state.go('recipeSearchStep', {
										step: '1'
									});
								}
							}
						}
					} else {
						//searchModal.open();
						$state.go('recipeSearchStep', {
							step: '1'
						});
					}
					break;
				case 2:
					currentUser.get().then(
						function(userModel) {
							if (!userModel._id) {
								//alert.push('success', 'open subscribe view');
								vm.openSubscribeView(true);
							} else {
								//alert.push('success', 'go to profilebecause if is set');
								$state.go('profile.info', {
									id: userModel._id
								});
							}
						},
						function() {
							//alert.push('danger', 'failed retrieving the user');
							//then here just prompt the layer to get authentication !
							vm.openSubscribeView(true);
						}
					);

					break;
			}
		};

		vm.goToHome = function() {
			$state.go('home');
		};

		vm.openSubscribeView = function(isLogin) {
			loginModal.open(isLogin);
		};

		vm.goToSearchStepOne = function() {
			$state.go('recipeSearchStep', {
				step: '1'
			});
		};

		vm.goToSearchResultByText = function() {
			$state.go('recipeTextSearchResult', {
				search: vm.searchQuery
			});
		};
	}
})();
